import { createFileRoute } from "@tanstack/react-router";
import { Newspaper } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { Briefing } from "@/features/research/modules/briefing/briefing";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/briefing/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.research_briefing_title() }),
});

function RouteComponent() {
  return (
    <PageShell icon={Newspaper} title={m.research_briefing_title()} description={m.research_briefing_description()}>
      <Briefing />
    </PageShell>
  );
}
